<div class="pi-sheet">

  <div class="pi-handle"></div>

  <ion-content class="pi-scroll" [scrollY]="true">
    <div class="pi-body">

      <!-- Icon -->
      <div class="pi-icon-wrap">
        <div class="pi-icon-ring">
          <ion-icon name="phone-portrait-outline" class="pi-app-icon"></ion-icon>
        </div>
      </div>

      <!-- Headline -->
      <div class="pi-text">
        <h2 class="pi-title">Install the app</h2>
        <p class="pi-subtitle">
          Add Bitbridge Billing to your home screen for faster access, offline support, and a
          full-screen experience — no browser bar in the way.
        </p>
      </div>

      <!-- Benefits -->
      <div class="pi-benefits">

        <div class="pi-benefit">
          <div class="pi-ben-icon-wrap">
            <ion-icon name="flash-outline"></ion-icon>
          </div>
          <div class="pi-ben-text">
            <p class="pi-ben-title">One tap to open</p>
            <p class="pi-ben-desc">Launch straight from your home screen, just like a native app.</p>
          </div>
        </div>

        <div class="pi-benefit">
          <div class="pi-ben-icon-wrap">
            <ion-icon name="notifications-outline"></ion-icon>
          </div>
          <div class="pi-ben-text">
            <p class="pi-ben-title">Stay notified</p>
            <p class="pi-ben-desc">Get transaction and balance alerts the moment they happen.</p>
          </div>
        </div>

        <div class="pi-benefit">
          <div class="pi-ben-icon-wrap">
            <ion-icon name="expand-outline"></ion-icon>
          </div>
          <div class="pi-ben-text">
            <p class="pi-ben-title">Full-screen, no clutter</p>
            <p class="pi-ben-desc">A distraction-free app view, without the browser address bar.</p>
          </div>
        </div>

      </div>

      <!-- iOS Safari: no native install API exists, so guide the user through Add to Home Screen -->
      <div class="pi-steps" *ngIf="!canInstallDirectly">
        <div class="pi-step">
          <div class="pi-step-num">1</div>
          <div class="pi-step-text">
            Tap the <ion-icon name="share-outline" class="pi-inline-icon"></ion-icon>
            <strong>Share</strong> button in Safari's toolbar.
          </div>
        </div>
        <div class="pi-step">
          <div class="pi-step-num">2</div>
          <div class="pi-step-text">
            Scroll down and tap <strong>Add to Home Screen</strong>.
          </div>
        </div>
        <div class="pi-step">
          <div class="pi-step-num">3</div>
          <div class="pi-step-text">
            Tap <strong>Add</strong> in the top-right corner.
          </div>
        </div>
      </div>

    </div>
  </ion-content>

  <!-- Fixed footer — always visible regardless of scroll position or device/safe-area size -->
  <div class="pi-actions">
    <ng-container *ngIf="canInstallDirectly; else iosGotIt">
      <ion-button expand="block" color="primary" class="pi-install-btn" (click)="install()">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        Install App
      </ion-button>
      <button class="pi-skip-btn" (click)="dismiss()">Not now</button>
    </ng-container>
    <ng-template #iosGotIt>
      <ion-button expand="block" color="primary" class="pi-install-btn" (click)="dismiss()">
        Got it
      </ion-button>
    </ng-template>
  </div>

</div>
